import { groupedSeedPageSize } from '@/platform/lists/lib/listSeedRequest';
import {
  myStudiesRowsRead,
  readMyStudiesGrouping,
  readMyStudiesTableId,
} from './myStudiesListCache';
import { myStudiesSnapshotToPaint } from './clinicalTrialsSnapshot';

/**
 * `includeRows` asks the opening for the first page of every row as well, which
 * a List grouped by chat reads next (allRowsReadPath).
 */
export function myStudiesOpeningUrl(
  pageSize = groupedSeedPageSize(),
  includeSeed = true,
  includeRows = false
): string {
  return `/clinical-trials/my-studies/opening?seedPageSize=${pageSize}${includeSeed ? '' : '&includeSeed=false'}${includeRows ? '&includeRows=true' : ''}`;
}

/**
 * How many rows of each status the opening's List seed carries. A List grouped
 * by chat reads every row anyway and shows no status sections, so its seed
 * brings the List's columns and one row of each status.
 */
export function myStudiesSeedPageSize(userKey: string | null, storage?: Storage): number {
  return userKey && readMyStudiesGrouping(userKey, storage) === 'chat' ? 1 : groupedSeedPageSize();
}

/**
 * The reads Clinical Trials opens with. For a user whose My studies last opened
 * grouped by chat, that includes the read of every row, which otherwise waits
 * for the opening to name the List; without that, the opening brings the rows
 * itself when the List groups by chat. A List this tab kept a snapshot of
 * paints from it and reads its opening and rows once the screen shows
 * (MyStudiesTab), so neither is among them. The viewer list is read by each
 * of its consumers with their own authorization header, so it is not either.
 */
export function clinicalTrialsOpeningRequests(
  userKey: string | null = null,
  storage?: Storage
): readonly string[] {
  const rows = userKey ? myStudiesRowsRead(userKey, storage) : null;
  const painted =
    rows !== null &&
    userKey !== null &&
    myStudiesSnapshotToPaint(userKey)?.opening.listId === readMyStudiesTableId(userKey, storage);
  return [
    ...(painted ? [] : [myStudiesOpeningUrl(myStudiesSeedPageSize(userKey, storage), true, !rows)]),
    ...(rows && !painted ? [rows] : []),
    '/investigator/studies',
  ];
}
